import React, { ReactNode } from 'react';

export interface LabelProps {
  children: ReactNode;
}

export const Label = ({ children }: LabelProps) => (
  <span className='v2-text-neutral-900 text-base'>{children}</span>
);
